import * as React from "react";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { difficultyRange } from "source/app/presentation/MainPanel/Dreams/DreamHelpers/DreamHelpers";
import { FilterByDifficultyOptions } from "source/app/presentation/MainPanel/Dreams/Filter/Difficulty/FilterByDifficultyOptions";


export function FilterByDifficulty({
    styles,
    onChange,
    selectedDifficulty,
}: FilterByDifficultyOptions) {
    return (
        <div className={styles.difficultyContainer} id="difficultySelector">
            <FormSelect
                id="difficulty"
                label="Difficulty"
                width="24%"
                classes={styles.difficultySelector}
                suggestions={difficultyRange.map((elem) => elem.toString())}
                onChange={onChange}
                value={selectedDifficulty} />
        </div>
    );
}
